// extracted by mini-css-extract-plugin
module.exports = {"legal":"LegalInfo_legal__MfAIC","contactInfo":"LegalInfo_contactInfo__4g0uA","legalInfo":"LegalInfo_legalInfo__T4Fnj","reservedRights":"LegalInfo_reservedRights__kMPRk"};